import { CaptureTime, readCaptureTime } from "./captureTime";
import { OVERVIEW_QUALITY, PhotoQuality, compressToFile } from "./compressImage";

export interface PreparedPhoto {
  /** 줄인 사진 (이름은 baseName + 확장자) */
  file: File;
  /** 줄이기 전에 읽은 촬영 시각. 못 읽으면 null */
  capture: CaptureTime | null;
}

/**
 * 업로드할 사진 준비: 촬영 시각을 먼저 읽고 줄인다.
 * 줄이면 사진 안의 촬영 정보가 지워지므로 순서가 중요하다.
 * 업로드할 수 없는 파일(확장자 없음)이면 null.
 */
export async function preparePhoto(
  file: File,
  baseName: string,
  quality: PhotoQuality = OVERVIEW_QUALITY
): Promise<PreparedPhoto | null> {
  const capture = await readCaptureTime(file);
  const prepared = await compressToFile(file, baseName, quality);
  return prepared ? { file: prepared, capture } : null;
}
